import React from 'react';
import PropTypes from 'prop-types';
import Pill from './Pill';
import { PILL_TONES, PILL_SIZES } from './tones';

// What something is, rather than how it is doing: a tag, an asset's source, a workflow type, a
// user's role. Pill-shaped, and deliberately off the severity ramp — green on a label would
// claim a tag is "good".
//
// Neutral is the default and covers almost everything. `info` is kept for one case that really
// is a kind rather than a state: an asset or document that came from an integration is a
// different sort of object from an internal one, and admins scan for exactly that.
export default function LabelPill({ tone, icon, size, title, className, onRemove, removeLabel, children }) {
  return (
    <Pill
      tone={tone}
      size={size}
      shape="pill"
      icon={icon}
      title={title}
      className={className}
      onRemove={onRemove}
      removeLabel={removeLabel}
    >
      {children}
    </Pill>
  );
}

LabelPill.propTypes = {
  tone: PropTypes.oneOf(Object.keys(PILL_TONES)),
  icon: PropTypes.string,
  size: PropTypes.oneOf(PILL_SIZES),
  title: PropTypes.string,
  className: PropTypes.string,
  onRemove: PropTypes.func,
  removeLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
};

LabelPill.defaultProps = {
  tone: 'neutral',
  icon: undefined,
  size: 'standalone',
  title: undefined,
  className: '',
  onRemove: undefined,
  removeLabel: undefined,
};
